<template>
    <div class="wrapper">
        <article>
            <h1>{{ $t('privacy-policy.title') }}</h1>
            <div class="version">{{ $t('privacy-policy.version') }}</div>
            <h2>{{ $t('privacy-policy.title') }}</h2>
            <i18n-t keypath="privacy-policy.guarantee.text" tag="p" scope="global">
                <template #company>
                    <strong>{{ $t('general.company') }}</strong>
                </template>
            </i18n-t>

            <h2>{{ $t('privacy-policy.consent.title') }}</h2>
            <i18n-t keypath="privacy-policy.consent.text" tag="p" scope="global">
                <template #company>
                    <strong>{{ $t('general.company') }}</strong>
                </template>
            </i18n-t>

            <h2>{{ $t('privacy-policy.questions.title') }}</h2>
            <i18n-t keypath="privacy-policy.questions.text" tag="p" scope="global">
                <template #company>
                    <strong>{{ $t('general.company') }}</strong>
                </template>
                <template #email>
                    <a :href="`mailto:${$t('general.email')}`">{{ $t('general.email') }}</a>
                </template>
            </i18n-t>

            <h2>{{ $t('privacy-policy.monitoring.title') }}</h2>
            <i18n-t keypath="privacy-policy.monitoring.text" tag="p" scope="global">
                <template #company>
                    <strong>{{ $t('general.company') }}</strong>
                </template>
            </i18n-t>

            <h2>{{ $t('privacy-policy.use-of-cookies.title') }}</h2>
            <i18n-t keypath="privacy-policy.use-of-cookies.text" tag="p" scope="global">
                <template #company>
                    <strong>{{ $t('general.company') }}</strong>
                </template>
            </i18n-t>

            <h2>{{ $t('privacy-policy.disable-cookies.title') }}</h2>
            <i18n-t keypath="privacy-policy.disable-cookies.text" tag="p" scope="global">
                <template #company>
                    <strong>{{ $t('general.company') }}</strong>
                </template>
            </i18n-t>

            <h2>{{ $t('privacy-policy.third-party-cookies.title') }}</h2>
            <i18n-t keypath="privacy-policy.third-party-cookies.text" tag="p" scope="global">
                <template #company>
                    <strong>{{ $t('general.company') }}</strong>
                </template>
            </i18n-t>

            <h2>{{ $t('privacy-policy.third-party-privacy.title') }}</h2>
            <i18n-t keypath="privacy-policy.third-party-privacy.text" tag="p" scope="global">
                <template #company>
                    <strong>{{ $t('general.company') }}</strong>
                </template>
            </i18n-t>
        </article>
    </div>
</template>

<script setup lang="ts">
    definePageMeta({
        layout: 'default',
        category: 'legal',
        title: 'privacy-policy.title',
    });
</script>

<style scoped lang="scss">
    @use '@/assets/mixins/containers.scss' as *;
    @use '@/assets/mixins/vertical-rhythm.scss' as *;

    .wrapper {
        height: 100%;
        overflow: scroll;
    }

    article {
        margin: 0 auto;

        @include content(90%);

        @include breakpoint(medium) {
            @include content(750px);
        }

        h1 {
            font-size: 1.94em;
            line-height: 1.68em;
            margin-bottom: 0.355em;
            padding-top: 0.484em;
        }

        :deep(h2) {
            font-size: 1.56em;
            line-height: 1.04em;
            margin-bottom: 0;
            padding-top: 0.2em;
        }

        h3 {
            font-size: 1.25em;
            line-height: 1.3em;
            margin-bottom: 1em;
            padding-top: 0.3em;
        }

        h4 {
            font-size: 1em;
            line-height: 1.63em;
            margin-bottom: 1.13em;
            padding-top: 0.5em;
        }

        :deep(p) {
            font-size: 1em;
            line-height: 1.63em;
            margin-bottom: 1.13em;
            padding-top: 0.5em;
        }

        :deep(strong) {
            color: hsl(var(--primary-500));
        }
    }
</style>
